/**
 * Analytics for add to home mobile component. What do we have here:
 *   - Listener for openBookmarkTip method. Everytime the user clicks on the button,
 *     we send an event.
 */
import Analytics from '@module/analytics';

export const actions = {};

export const states = {};

export const methods = {
  openBookmarkTip() {
    Analytics.pushDataLayerEvent({
      category: 'Upsell',
      action: 'click',
      label: 'open bookmark tip',
    });
  },
};
